<template>
  <app-base-main style="margin-top: -10px">
    <template #operate-group>
      <span class="icon-back" @click="goBack"><gj-icon iconfont="iconback"></gj-icon>&nbsp;返回</span>
      <span class="base-text">|</span>
      <span class="nav-tips"><span class="icon-back" @click="goBack">发货计划</span>&nbsp;<i class="el-icon-arrow-right"></i>
        <span class="tips-to">&nbsp;批次详情</span>
      </span>
    </template>
    <template #base-content>
      <div class="content-cell">
        <div class="header">
          批次详情
        </div>
        <div class="header-content">
          <div class="header-content__item">
            <span class="label">批次号：</span>
            <span class="value">{{ shipPlanDetail.code | defaultShow }}</span>
          </div>
          <div class="header-content__item">
            <span class="label">创建人：</span>
            <span class="value">{{ shipPlanDetail.createUserName | defaultShow }}</span>
          </div>
          <div class="header-content__item">
            <span class="label">创建时间：</span>
            <span class="value">{{ shipPlanDetail.createTime | defaultShow }}</span>
          </div>
          <div class="header-content__item">
            <span class="label">备注：</span>
            <gj-text class="value momo" max-width="200px">{{ shipPlanDetail.memo | defaultShow }}</gj-text>
            <el-popover placement="bottom" width="400px" v-model="popoverVisible" v-if="shipPlanDetail.code">
              <div class="purchase-plan-desc">
                <div class="title">备注修改</div>
                <br>
                <div>
                  <gj-textarea
                      v-model="memo"
                      :autosize="{ minRows: 3, maxRows: 3}"
                      placeholder="最多输入200个字"
                      maxLength="200"
                      class="form-input">
                  </gj-textarea>
                  <span style="font-size: 12px;margin-top: 10px">{{ memo && memo.length || 0 }}/200</span>
                  <div style="float: right;margin-top: 10px">
                    <gj-button size="mini" @click="popoverVisible=false" class="gj-btn">取消</gj-button>
                    <gj-button size="mini" type="primary" @click="confirm" class="gj-btn" :loading="confirmLoading">确定
                    </gj-button>
                  </div>
                </div>
                <div>
                </div>
              </div>
              <i class="el-icon-edit" slot="reference"></i>
            </el-popover>
          </div>
        </div>
        <div style="display:flex;justify-content: space-between;height: 40px;">
          <gj-area-title>发货商品</gj-area-title>
          <gj-tool-group style="margin-top: -10px" :sort-gjtable="$refs.gjTable"
                         setting :table-name="'delivery-plan-details'" :table-columns="columns"></gj-tool-group>
        </div>
        <gj-table
            ref="gjTable"
            name="transferProductAddModal"
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :offset-height="80"
            selection
            @sort-change="$gjSortChange"
        >
          <template v-slot:productName="{ row }">
            <div>
              <gj-text width="90%">{{ row.productName | defaultShow }}</gj-text>
            </div>
            <div>
              {{ row.sku | defaultShow }}
            </div>
          </template>
          <template v-slot:availableQuantity="{ row }">
            <div style="display: flex;">
              <span>
                  {{ row.availableQuantity | defaultShow }};&nbsp;{{ row.alreadyOrderQuantity | defaultShow }};
              &nbsp;{{ row.planWarehouseQuantity | defaultShow }}
              </span>
              <gj-popover trigger="hover" placement="bottom" width="600" v-if="row.productType=== 'Assembly' && row.warehouseId">
                <template>
                  <div>
                    <div class="maxNum">
                      <div>最大装配量：<span style="color: #EFA621;">{{ maxTableDataVo.maxAssemblyQuantity }}</span></div>
                    </div>
                    <gj-table
                        :columns="maxNumColumns"
                        ref="gjTable2"
                        :index="false"
                        name="maxNumTable"
                        :data="maxTableDataVo.voList"
                        :loading="maxLoading"
                        :size="'has-picture'"
                        :adapt-height="false"
                        :height="300"
                    >
                      <template v-slot:skuName="{row}">
                        <gj-text width="90%">{{ row.productName }}</gj-text>
                        <br>
                        <gj-text width="90%">{{ row.sku }}</gj-text>
                        <br>
                      </template>
                    </gj-table>
                  </div>
                </template>
                <div slot="reference" style="margin-left: 5px;color: #1F6EEF;">
                  <i class="el-icon-connection" @mouseover="getMaxNums(row.sku, row.warehouseId)"></i>
                </div>
              </gj-popover>
            </div>
          </template>
          <template v-slot:packageSize="{ row }">
            {{ row.packageL | defaultShow }} * {{ row.packageW | defaultShow }} * {{ row.packageH | defaultShow }}
          </template>
          <template v-slot:cartonSize="{ row }">
            {{ row.cartonSizeL | defaultShow }} * {{ row.cartonSizeW | defaultShow }} * {{
              row.cartonSizeH | defaultShow
            }}
          </template>
          <template v-slot:shipPlanShipments="{ row }">
            <span v-if="row.shipPlanShipments && row.shipPlanShipments.length > 0">
              <el-dropdown>
                  <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{ shipPlanDetail.shipPlanShipments[0] && shipPlanDetail.shipPlanShipments[0].shipmentId}} | {{shipPlanDetail.shipPlanShipments[0] && shipPlanDetail.shipPlanShipments[0].quantity }}
                      <i class="el-icon-arrow-down el-icon--right"
                         v-if="shipPlanDetail.shipPlanShipments.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="shipPlanDetail.shipPlanShipments.length > 1">
                      <template v-for="(item,key) in shipPlanDetail.shipPlanShipments">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">{{ item.shipmentId + " | " + item.quantity }}</span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                 </el-dropdown>
             </span>
            <span v-else>-</span>
          </template>
          <template v-slot:shipPlanTransfers="{ row }">
            <span v-if="row.shipPlanTransfers && row.shipPlanTransfers.length > 0">
               <span v-if="shipPlanDetail.shipPlanTransfers && shipPlanDetail.shipPlanTransfers.length > 0">
                 <el-dropdown>
                  <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{ shipPlanDetail.shipPlanTransfers[0].transferCode + ' | ' + shipPlanDetail.shipPlanTransfers[0].quantity }}
                      <i class="el-icon-arrow-down el-icon--right"
                         v-if="shipPlanDetail.shipPlanTransfers.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="shipPlanDetail.shipPlanTransfers.length > 1">
                      <template v-for="(item,key) in shipPlanDetail.shipPlanTransfers">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">{{ item.transferCode + " | " + item.quantity }}</span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                 </el-dropdown>
               </span>
             </span>
            <span v-else>-</span>
          </template>
          <template #footer>
            <div class="table-footer">
              <span style="margin-right: 20px">产品总数：{{ tableData && tableData.length | defaultShow }}</span>
              <span style="margin-right: 20px">总箱数：{{ sumPlanQuantity }}</span>
              <span style="margin-right: 20px">总计划发货量：{{ sumPackageQuantity }}</span>
              <span style="margin-right: 40px">总货值（预估）：{{ sumTotalCost }}</span>
            </div>
          </template>
        </gj-table>
        <div style="text-align: center;padding: 10px;">
          <gj-button  @click="addPurchasePlan" :loading="btnLoading.generatePurchasePlan"
                     v-if="$permission('shipPlan:generatePurchasePlan')">生成采购计划
          </gj-button>
          <gj-button  @click="addTransferSlip" :loading="btnLoading.generateTransfer"
                     v-if="$permission('shipPlan:generateTransfer')">生成调拨单
          </gj-button>
          <gj-button  @click="addPackage" :loading="btnLoading.generateShipment"
                     v-if="$permission('shipPlan:generateShipment')">创建货件
          </gj-button>
          <gj-button v-if="$permission('shipPlan:printLabels')" @click="printLabel">打印商品标签
          </gj-button>
        </div>
      </div>
    </template>
  </app-base-main>
</template>

<script>
import {
  getDeliveryMaxAssemblyQuantity,
  getShipPlanDetail,
  postShipPlanGenerateShipment,
  postShipPlanGenerateTransfer, postShipPlanPurchasePlanQuery, postUpdateMemo,
} from '@/api/logistics'
import {queryMixin, selectionMixin} from "@/minxins";
import {mapGetters} from "vuex";
import {operateOptions, statusEnum as StatusEnum, statusOption} from "../deliveryEnum";
import AppOpTransferOrderModal from "@/views/modules/warehouse/transfer-order/modal/op/op-transfer-order-modal";
import {OpEnum} from "@/utils/options";
import AddFbaShipmentModal from "@/views/modules/common/logistics/fba-shipment/modal/add/add-fba-shipment-modal";
import AppPrintLabelModal from "@/views/modules/logistics/fba-shipment/modal/print-label-modal";
import {defaultVal, isMeaningful} from "@/utils/common";
import {queryReviewSetting} from "@/api/purchase";
import OpPurchasePlanAddForDelivery from '@/views/modules/purchase/purchase-plan/modal/op-purchase-plan-add-for-delivery'

export default {
  name: "delivery-plan-detail",
  mixins: [queryMixin, selectionMixin],
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      popoverVisible: false,
      shipPlanDetail: {},
      tableData: [],
      batchOperate: '',
      operateOptions,
      StatusEnum,
      statusOption,
      reviewOption: false,
      purchaseVisible: false,
      opTypePurchase: 0,
      propRows: [],
      maxTableDataVo: {
        maxAssemblyQuantity: null,
        voList: []
      },
      memo: '',
      maxLoading:false,
      confirmLoading: false,
      btnLoading: {
        generateShipment: false,
        generateTransfer: false,
        generatePurchasePlan: false,
      },
      maxNumColumns: [
        {id: "picture", header: "图片", field: "picture:imageUrl", width: "50px", align: 'center', default: true,},
        {id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "160px", default: true,},
        {id: "requiredAmountPerUnit", header: "单位所需量", field: "requiredAmountPerUnit", width: "100px", default: true,},
        {id: "availableQuantity", header: "可用量", field: "availableQuantity", width: "90px", default: true,},
        {id: "alreadyOrderQuantity", header: "已下单", field: "alreadyOrderQuantity", width: "90px", default: true,},
        {id: "planWarehouseQuantity", header: "计划入库", field: "planWarehouseQuantity", width: "90px", default: true,},
      ],
      columns: [
        {id: 'code', header: '计划编号', field: 'code', width: '180px', default: true},
        {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px', default: true},
        {id: 'msku', header: 'MSKU/FNSKU', field: 'msku', width: '120px', default: true},
        {id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '130px', default: true},
        {
          id: 'marketId',
          header: '店铺/国家',
          field: 'option:marketId',
          minWidth: '120px',
          options: () => this.marketOption, default: true
        },
        {id: 'shipTime', header: '发货时间', field: 'shipTime', minWidth: '100px', default: true},
        {
          id: 'status',
          header: '状态',
          field: 'option:status',
          options: statusOption.open,
          minWidth: '90px',
          default: true
        },
        {id: 'transportShow', header: '物流方式', field: 'transportShow', minWidth: '100px', default: true},
        {id: 'warehouseName', header: '发货仓库', field: 'warehouseName', minWidth: '100px', default: true},
        {id: 'shipedPlanQuantity', header: '计划发货量', field: 'shipedPlanQuantity', minWidth: '100px', default: true},
        {
          id: 'availableQuantity',
          header: '可用量/已下单/计划入库',
          field: 'slot:availableQuantity',
          minWidth: '200px',
          default: true
        },
        {id: 'difference', header: '差额', field: 'difference', minWidth: '60px', default: true},
        {
          id: 'areCasesRequired',
          header: '包装类型',
          field: 'option:areCasesRequired',
          options: [{id: true, text: "原厂包装"}, {id: false, text: "混装"}],
          minWidth: '90px',
          default: true
        },
        {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '90px', default: true},
        {id: 'packageQuantity', header: '箱数', field: 'packageQuantity', minWidth: '60px', default: true},
        {id: 'packageSize', header: '包装尺寸（cm）', field: 'slot:packageSize', minWidth: '120px', default: true},
        {id: 'cartonSize', header: '箱规（cm）', field: 'slot:cartonSize', minWidth: '120px', default: true},
        {id: 'totalCapacity', header: '装箱总体积（m³）', field: 'totalCapacity', minWidth: '140px', default: true},
        {
          id: 'singleProductVolumeWeight',
          header: '单品计费重（kg）',
          field: 'singleProductVolumeWeight',
          minWidth: '140px',
          default: true
        },
        {
          id: 'singleProductNetWeight',
          header: '单品净重（g）',
          field: 'singleProductNetWeight',
          minWidth: '120px',
          default: true
        },
        {id: 'packageWeight', header: '单品毛重（g）', field: 'packageWeight', minWidth: '120px', default: true},
        {
          id: 'totalProductNetWeight',
          header: '总净重（kg）',
          field: 'totalProductNetWeight',
          minWidth: '120px',
          default: true
        },
        {id: 'totalPackageWeight', header: '总毛重（kg）', field: 'totalPackageWeight', minWidth: '120px', default: true},
        {
          id: 'arriveCost',
          header: '到库成本（预估）',
          field: 'arriveCost',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '120px',
          default: true
        },
        {
          id: 'purchaseCost',
          header: '采购成本（预估）',
          field: 'purchaseCost',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '120px',
          default: true
        },
        {
          id: 'totalValue',
          header: '总货值(预估)',
          field: 'totalValue',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '120px',
          default: true
        },
        {
          id: 'shipPlanShipments',
          header: '货件单号|申报量',
          field: 'slot:shipPlanShipments',
          minWidth: '200px',
          default: true
        },
        {
          id: 'shipPlanTransfers',
          header: '调拨单号|调拨量',
          field: 'slot:shipPlanTransfers',
          minWidth: '200px',
          default: true
        },
        {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '120px', default: true},
        {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '155px', default: true},
        {id: 'memo', header: '备注', field: 'memo', minWidth: '180px', default: true},
      ]
    }
  },
  created() {
    this.queryReviewOption();
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    sumPlanQuantity() {
      let sum = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          if (item.packageQuantity) sum += Number(item.packageQuantity)
        })
      }
      return sum;
    },
    sumPackageQuantity() {
      let sum = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          if (item.shipedPlanQuantity) sum += Number(item.shipedPlanQuantity)
        })
      }
      return sum;
    },
    sumTotalCost() {
      let sum = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          if (item.totalValue) sum += Number(item.totalValue)
        })
      }
      return sum;
    }
  },
  methods: {
    confirm() {
      if (this.memo && this.memo.length <= 200) {
        this.confirmLoading = true;
        postUpdateMemo({
          id: this.shipPlanDetail.planBatchId,
          memo: defaultVal(this.memo, " "),
        })
            .then(() => {
              this.popoverVisible = false;
              this.$gjQuery();
            })
            .complete(() => this.confirmLoading = false);
      } else {
        this.$gjMessage.error("请输入备注，且不能超过200个字符")
      }
    },
    closeOpen(val) {
      if (val === 'refresh') this.$gjQuery();
      this.purchaseVisible = false;
    },
    // 查询是否开启审批
    queryReviewOption() {
      queryReviewSetting({name: 'SHIP_PLAN_REVIEW_SETTING'}).then(res => {
        this.reviewOption = res;
      })
    },
    $gjQuery() {
      this.getShipPlanDetail(this.id)
    },
    hidePopover() {
      document.body.click()
    },
    goBack() {
      this.$emit('goBack')
    },
    // 获取 最大 可用量
    getMaxNums(sku, warehouseId) {
      this.maxTableDataVo = {
        maxAssemblyQuantity: null,
        voList: []
      }
      this.maxLoading = true;
      getDeliveryMaxAssemblyQuantity(sku, warehouseId).then(res => {
        if (isMeaningful(res)) this.maxTableDataVo = res;
      }).complete(()=> this.maxLoading = false)
    },
    getShipPlanDetail(id) {
      if (id) {
        this.loading = true
        getShipPlanDetail(id).then(res => {
          this.shipPlanDetail = Object.assign({}, this.shipPlanDetail, res)
          this.shipPlanDetail.planBatchId = this.shipPlanDetail.id;
          this.tableData = res.shipPlanList
          this.tableData.forEach(item => {
            item.currencySymbol = '￥';
          })
          this.memo = this.shipPlanDetail.memo;
        }).complete(() => this.loading = false)
      }
    },
    addPurchasePlan() {
      let rows = this.selectedRows;
      if(rows.length === 0){
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if(this.selectedSomeIsNot('status',StatusEnum.WAIT_HANDLE)){
        this.$gjMessage.warning("只有待处理状态的才能生成采购计划");
        return false;
      }
      this.btnLoading.generatePurchasePlan = true;
      postShipPlanPurchasePlanQuery({idList: rows.map(item => item.id)}).then(res => {
        if (res && res.length > 0) {
          const modal = this.$gjCreate(OpPurchasePlanAddForDelivery, {
            props: {
              opType: 0,
              delivery: true,
              deliveryList: res,
              appendHeight: 80,
            },
            on: {
              closeOpen: (res) => {
                modal.$gjDestroy();
                if(res){
                  this.$gjResetPage();
                }
              },
            },
          });


        }
      }).complete(() => this.btnLoading.generatePurchasePlan = false)
    },
    // 创建货件
    addPackage() {
      let rows = this.selectedRows;
      if(rows.length === 0){
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if(this.selectedSomeIsNot('status',StatusEnum.WAIT_HANDLE)){
        this.$gjMessage.warning("只有待处理状态的才能创建货件");
        return false;
      }
      this.btnLoading.generateShipment = true;
      postShipPlanGenerateShipment({idList: rows.map(item => item.id)}).then(data => {
        this.$gjCreate(AddFbaShipmentModal, {
          props: {
            deliveryPlan: data,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        });
      }).complete(() => this.btnLoading.generateShipment = false)
    },
    // 生成调拨单
    addTransferSlip() {
      let rows = this.selectedRows;
      if(rows.length === 0){
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if(this.selectedSomeIsNot('status',StatusEnum.WAIT_HANDLE)){
        this.$gjMessage.warning("只有待处理状态的才能生成调拨单");
        return false;
      }
      this.btnLoading.generateTransfer = true;
      postShipPlanGenerateTransfer({idList: rows.map(item => item.id)}).then(res => {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            deliveryPlan: res,
            opType: OpEnum.type.ADD,
            header: "添加调拨单",
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        })
      }).complete(() => this.btnLoading.generateTransfer = false);
    },
    // 打印标签
    printLabel() {
      let rows = this.selectedRows;
      if(rows.length === 0){
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      this.$gjCreate(AppPrintLabelModal, {
        props: {
          ids: [],
          deliveryPlan: rows,
        },
        on: {
          created: () => {
            this.$gjResetPage();
          },
        },
      });
    },
  }
}
</script>

<style scoped lang="scss">
.nav-tips {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  font-weight: 400;
}

.tips-to {
  color: #333333;
}

.content-cell {
  background: #fff;
  padding: 15px;
}

.header {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  font-weight: 600;
  padding-bottom: 15px;

  &-content {
    padding: 16px;
    background: #F7F8FA;
    font-size: 12px;
    margin-bottom: 20px;

    &__item {
      display: inline-block;
      margin-right: 40px;

      .label {
        color: #666;
      }

      .value {
        color: #333;
      }
      .memo{
        width: 220px;
      }
    }
  }
}

.table-footer {
  text-align: right;
  height: 38px;
  line-height: 38px;
  background: #F6F8FB;
  font-size: 12px;
  color: #333333;
  font-weight: 600;
  padding-right: 20px;
}

/deep/ .gj-dialog-plan {
  .purchase-plan{
    padding: 0;
    margin-top: -50px !important;
  }
}
.base-text{
  color: #999999;
  font-size: 12px;
}
.icon-back{
  color: #999999;
  font-size: 12px;
  cursor: pointer;
}
.icon-back:hover{
  color: #5d9bfc;
}
</style>
